import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { JobCard } from "../../components/JobCard";
import { useAuth } from "../../context/AuthContext";
import { CheckCircle2, Sun } from "lucide-react";

export default function FieldToday() {
  const { data, loading } = useFetch("/dashboard/field");
  const { user } = useAuth();
  if (loading || !data) return <Loading label="Loading today" />;

  const today = new Date().toLocaleDateString([], { weekday: "long", month: "long", day: "numeric" });

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center gap-2 text-cyan-400"><Sun size={16} /><span className="hw-eyebrow">{today}</span></div>
        <h1 className="mt-1 font-head text-4xl font-black text-white">Today</h1>
        <p className="mt-1 text-slate-400">Hey {user?.name?.split(" ")[0]}, you have {data.today.length} jobs today.</p>
      </div>

      {data.today.length === 0 ? (
        <EmptyState title="No jobs today" subtitle="Enjoy the day — check Schedule for upcoming work." icon={CheckCircle2} />
      ) : (
        <div className="space-y-4">
          {data.today.map((j) => <JobCard key={j.id} job={j} />)}
        </div>
      )}

      {data.upcoming.length > 0 && (
        <div className="pt-4">
          <div className="hw-eyebrow mb-3">Coming up</div>
          <div className="space-y-4 opacity-80">
            {data.upcoming.slice(0, 3).map((j) => <JobCard key={j.id} job={j} />)}
          </div>
        </div>
      )}
    </div>
  );
}
